function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h20v20H0z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M16.93 2.68c-.12-.3-.41-.63-.68-.79L13.22.1c-.45-.26-1.01.02-1.09.49l-.96 4.29c-.07.4.14.86.49 1.06l1.34.89c.08.05.2.21.22.29 0 .01.26 1.29-1.38 4.2-1.63 2.9-2.82 3.31-2.9 3.32-.12 0-.23-.03-.27-.06l-1.54-1.01c-.35-.21-.86-.16-1.19.15l-2.93 3.06c-.18.17-.28.4-.25.64.02.23.16.44.38.57l3.03 1.8c.23.12.56.21.85.21.06 0 .11 0 .17-.01.16-.02 3.89-.59 7.54-7.08s2.26-10.08 2.2-10.23z"
});

function SvgIconCall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    id: "icon-earphone",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCall);
export default __webpack_public_path__ + "static/media/icon-call.d6388d85.svg";
export { ForwardRef as ReactComponent };